import { useState } from 'react';

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

/** Keypad (DTMF into the call) and on-demand record toggle (AE-10987). */
export function CallExtras({ live, recording, mode, onDtmf, onRecord }: {
  live: boolean; recording: boolean; mode: string | undefined; onDtmf: (digit: string) => void; onRecord: () => void;
}) {
  const [pad, setPad] = useState(false);
  const canRecord = mode !== 'NEVER';
  return (
    <>
      <button onClick={() => setPad((v) => !v)} disabled={!live} aria-expanded={pad}>Keypad</button>
      {canRecord && (
        <button className={recording ? 'danger' : undefined} onClick={onRecord} disabled={!live || (recording && mode === 'ALLFORCE')}
          title={mode === 'ALLFORCE' && recording ? 'Recording is required for this campaign' : undefined}>
          {recording ? 'Stop rec' : 'Record'}
        </button>
      )}
      {pad && live && (
        <div id="x5-dtmf-pad" role="group" aria-label="Keypad">
          {KEYS.map((k) => <button key={k} onClick={() => onDtmf(k)}>{k}</button>)}
        </div>
      )}
    </>
  );
}
